// extracted by mini-css-extract-plugin
export default {"page":"InstallingWorkerPage-module__page","messages":"InstallingWorkerPage-module__messages","progress":"InstallingWorkerPage-module__progress"};